"use client";
import Image from "next/image";
import Link from "next/link";
import { motion } from "framer-motion";
const LatestProjectCard = () => {
  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      transition={{ ease: "easeInOut", duration: 0.3 }}
      className="relative w-full max-w-4xl mx-auto overflow-hidden cursor-pointer"
    >
      {/* Background Image */}
      <Image
        src="/pictures/latestproject.jpg" // Make sure this image is in /public/images/
        alt="Latest Project"
        width={1200}
        height={600}
        className="w-full h-auto object-cover"
        loading="lazy"
      />

      {/* Overlay */}
      <Link
        href="https://www.instagram.com/kingofstrength/reel/DGdKDlkpX_w/?hl=en"
        className="absolute inset-0 flex items-center justify-center bg-black/40 hover:bg-black/60 transition-all"
        target="_blank"
      >
        <span className="text-white text-lg font-semibold uppercase tracking-wide">
          The Latest Project ↗
        </span>
      </Link>
    </motion.div>
  );
};

export default LatestProjectCard;
